
import makerjs from "makerjs";
function A22(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,H = Param[1].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
      //  w1 = W1 * 1 * myZoom,
      //  h1 = H1 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = w, x2 = w,  y0 = 0, y1 = h, y2 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } 
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA22 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "RightLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
        "BottomLine": new makerjs.paths.Line([x2, y2], [x0, y0]),
       }
   };
   var drawAbnormalShapeA22MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1+ markShift, y1], [x1+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x1, y1], [x1+ 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2]),
       }
   };
   var drawAbnormalShapeA22MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x2, y2 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA22MarkW, TxtW, [x0, y0 - 2 * markShift], [x2, y2 - 2 * markShift]);//长度文字 
   makerjs.model.addCaption(drawAbnormalShapeA22MarkH, TxtH, [x1 + 2 * markShift, y2], [x1 + 2 * markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA22: drawAbnormalShapeA22,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA22: drawAbnormalShapeA22,
        drawAbnormalShapeA22MarkH:drawAbnormalShapeA22MarkH,
        drawAbnormalShapeA22MarkW:drawAbnormalShapeA22MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A22;